import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirm Email Address',
  [OnboardingStep.BusinessInfo]: 'Add your store details',
  [OnboardingStep.PersonalInfo]: 'Add your personal information',
  [OnboardingStep.ShippingInfo]: 'Add your delivery information',
  [OnboardingStep.BankInfo]: 'Add bank details for payouts',
  [OnboardingStep.TaxInfo]: 'Is your business VAT registered?',
  [OnboardingStep.BusinessDocs]: 'Proof of business document',
  [OnboardingStep.PersonalDocs]: 'Proof of identity document',
  [OnboardingStep.InfoSubmission]: 'Get paid',
  confirm_info_gateway: 'Get paid – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Payment info',
  [OnboardingStep.Subscription]: 'Subscription',
  [OnboardingStep.MobileApp]: 'Mobile app',
  [OnboardingStep.DeliveryStructure]: 'Delivery structure',
  [OnboardingStep.Contract]: 'Contract',
  [OnboardingStep.ContractPayment]: 'Contract payment',
  [OnboardingStep.PromoCode]: 'Promo code',
};
